import { format, parseISO } from "date-fns";

export const formatDateForApi = (value) => (value ? format(new Date(value), "yyyy-MM-dd") : null);

export const parseDateForPicker = (value) => (value ? parseISO(value) : null);
